// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"F2-z","colorTextValue":"G2-z","swatches":"H2-z","collapseLink":"I2-z","isCollapsed":"J2-z","dropdown":"K2-z","disabled":"L2-z"};